var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        transition: "dialog-bottom-transition",
        overlay: false
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { staticClass: "primary", attrs: { dark: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.transferChatFermer()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-toolbar-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("toTransfer")))]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-toolbar-items")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "grey lighten-4", attrs: { fluid: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "dialogTransfert", attrs: { xs12: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "heightDialogTransfert",
                          attrs: { flat: "" }
                        },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "contentDialogListeAgent" },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "ListeAgent",
                                  attrs: { xs12: "" }
                                },
                                [
                                  _vm.messageTransfereStatus.automatique
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("messageAgentIndispo")
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("selectAgentToTransfer")
                                          )
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("wz-list-agents", {
                                    attrs: {
                                      agentSelect: _vm.selectedAgent,
                                      inMonitoring: false,
                                      visiteurSiteID: _vm.datasVisiteur.siteID
                                    },
                                    on: {
                                      "update:agentSelect": function($event) {
                                        _vm.selectedAgent = $event
                                      },
                                      "update:agent-select": function($event) {
                                        _vm.selectedAgent = $event
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "heightDialogTransfertBT",
                          attrs: { flat: "" }
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-flex", { attrs: { xs12: "" } }, [
                                _vm.selectedAgent.id !== "" &&
                                _vm.selectedAgent.status === "online"
                                  ? _c("div", {
                                      staticClass: "wz_txtTopBtnTransfere",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$tc("agentSelectedSupport", 0, {
                                            count: _vm.selectedAgent.name
                                          })
                                        )
                                      }
                                    })
                                  : _vm.selectedAgent.id !== "" &&
                                    _vm.selectedAgent.status !== "online"
                                  ? _c("div", {
                                      staticClass: "wz_txtTopBtnTransfere",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$tc(
                                            "agentNotAvailableSupport",
                                            0,
                                            { count: _vm.selectedAgent.name }
                                          )
                                        )
                                      }
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "wz_txtTopBtnTransfere" },
                                      [_vm._v(_vm._s(_vm.$tc("agents", 0)))]
                                    )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _vm.selectedAgent.status === "online"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            dark: "",
                                            loading: _vm.loadingDialog
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.transferChat()
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("toTransfer")))]
                                      )
                                    : _vm.selectedAgent.status !== "online"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            light: "",
                                            disabled: ""
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("toTransfer")))]
                                      )
                                    : _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            light: "",
                                            disabled: ""
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("toTransfer")))]
                                      ),
                                  _vm._v(" "),
                                  _vm.messageTransfereStatus.status === "wait"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", dark: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.annuleTransfer()
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.messageTransfereStatus.status === "no"
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            medium: "",
                                            color: "orange darken-2"
                                          }
                                        },
                                        [_vm._v("warning")]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          _vm.messageTransfereStatus.message
                                        ) + "\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026d32f3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026d32f3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogTransfertChat.vue
// module id = null
// module chunks = 